import cs from 'classnames';
import type React from 'react';

export type SectionProperties = {
  lineTop?: boolean;
  lineBottom?: boolean;
  paddingTop?: boolean;
  paddingBottom?: boolean;
  className?: string;
};

const Section: React.FC<SectionProperties> = ({
  lineTop = false,
  lineBottom = true,
  paddingTop = true,
  paddingBottom = true,
  className,
  ...rest
}) => {
  return (
    <div
      className={cs('form__section', className, {
        'form__section-top-padding': paddingTop,
        'form__section-top': lineTop,
        'form__section-bottom-padding': paddingBottom,
        'form__section-bottom': lineBottom,
      })}
      {...rest}
    />
  );
};

export default Section;
